@if (isOpen()) {

  <div class="modal-backdrop-custom"
       (click)="close.emit()"></div>

  <div class="modal d-block">
    <div class="modal-dialog modal-dialog-centered"
         [ngClass]="'modal-' + size()">

      <div class="modal-content custom-modal p-4">

        <!-- Header -->
        <div class="modal-header border-0">
          <h5 class="modal-title fw-semibold">
            {{ title() }}
          </h5>

          <button class="btn-close" (click)="close.emit()"></button>
        </div>

        <!-- Body -->
        <div class="modal-body custom-body">
          <ng-content></ng-content>
        </div>

        <!-- Footer -->
        @if (showFooter()) {
          <div class="modal-footer border-0 d-flex gap-2">

            <!-- Static Close Button -->
            <p-button
              label="Close"
              icon="pi pi-times"
              severity="danger"
              (onClick)="close.emit()">
            </p-button>

            <!-- 🔥 Dynamic PrimeNG Button -->
            @if (showPrimary()) {
            <p-button
              [label]="primaryLabel()"
              [icon]="primaryIcon()"
              [loading]="primaryLoading()"
              [disabled]="primaryDisabled()"
              (onClick)="primaryAction.emit()">
            </p-button>
            }

          </div>
        }

      </div>
    </div>
  </div>
}
